import { createContext, useContext } from 'react';
import { GetActionMap } from 'api/actions/actions';

/**
 * The session context interface.
 */
export interface IApiContext {
  /**
   * The JWT token.
   */
  jwt: string;

  /**
   * The building ID for filtering data by building.
   */
  buildingId: number | null;

  /**
   * Starts an authenticated session and clears any previous building selection.
   */
  startSession: (token: string) => void;

  /**
   * Selects the building used by building-scoped helpdesk pages.
   */
  selectBuilding: (buildingId: number | null) => void;

  /**
   * Clears the authenticated session and selected building.
   */
  clearSession: () => void;

  /**
   * Returns the action with the given operationId.
   */
  getAction: GetActionMap;
}

/**
 * The session context is used to store the current session.
 *
 * The session context will be provided in <App>.
 */
export const ApiContext = createContext<IApiContext>(undefined!);

/**
 * The use API hook.
 */
export function useApi() {
  return useContext(ApiContext);
}
